import { trpcTenant } from './trpcTenant';
import type { NotificationChannelMessage } from '@duke-hq/svc-api/provider/web-api';

interface WithNotificationsProps {
  children: React.ReactNode;
}

type Utils = ReturnType<typeof trpcTenant.useUtils>;

// -- Type-safe invalidation config — keyed by notification type ----------
const invalidationHandlers: Partial<
  Record<NotificationChannelMessage['type'], (utils: Utils) => void>
> = {
  unreadTicketCount: (utils) => {
    void utils.support.listTickets.invalidate();
  },
};

/**
 * Type-safe automatic cache updater for SSE notifications.
 *
 * Convention: notification.type must match the tRPC query procedure name.
 */
export function WithNotifications({ children }: WithNotificationsProps) {
  const utils = trpcTenant.useUtils();

  trpcTenant.notifications.subscribe.useSubscription(undefined, {
    onData: (notification) => {
      // Update the react-query cache with the notification payload
      try {
        utils.notifications[notification.type].setData(
          undefined,
          // @ts-expect-error -- discriminated union narrowing lost through dynamic key access
          notification.payload,
        );
      } catch {
        // Catch silently to prevent type mismatches from breaking SSE subscription
        return;
      }

      // Run type-safe invalidations
      invalidationHandlers[notification.type]?.(utils);
    },
  });

  return children;
}
